module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1112.6b55c19c.png";